import * as React from 'react';
import { Trans } from 'react-i18next';
import { Text } from '@wix/design-system';
import { withInjectedRootStore, RootStore } from 'providers';
import { SaleBannerSubtitle } from './SaleBannerSubtitle';
import s from './SaleBanner.scss';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import { useSaleBannerTitle } from './useSaleBannerTitle';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import classNames from 'classnames';

interface SaleBannerContentProps extends InjectedExperimentsProps {
  rootStore: RootStore;
}

const SaleBannerContentComp: React.FunctionComponent<SaleBannerContentProps> = ({
  rootStore,
  experiments,
}) => {
  const { discountPercent } = rootStore.appStore.appContext.saleParams;
  const bannerTitle = useSaleBannerTitle(rootStore.appStore, experiments);
  const { theme } = usePageModeContext();

  return (
    <div className={s.saleText}>
      <Text
        className={classNames(s.saleSubtitle, theme)}
        weight='normal'
        size='small'
      >
        <SaleBannerSubtitle />
      </Text>
      <Text
        className={classNames(s.saleTitle, theme)}
        weight='bold'
        size='small'
      >
        <Trans
          i18nKey={bannerTitle}
          values={{ percent: discountPercent || '50' }}
        >
          <span className={classNames(s.saleDiscount, theme)}>
            SAVE {{ percent: discountPercent || '50' }}%
          </span>
          rest
        </Trans>
      </Text>
    </div>
  );
};

export const SaleBannerContent = withInjectedRootStore(
  withExperiments(SaleBannerContentComp),
);
